// extracted by mini-css-extract-plugin
export default {"main":"CoinContent_main__35ord","content":"CoinContent_content__aKIfI","bttn":"CoinContent_bttn__EVTVT","arrows1":"CoinContent_arrows1__Wm0uj","arrows2":"CoinContent_arrows2__lMF1T"};